import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const ThemeColumn = withStyles(CoreView, {style: {flexDirection: 'column'}});